<app-prime-table
  queryParamProperty="finding"
  [data$]="findingsCurrentPage$"
  [rowsPerPage]="defaultPageSize()"
  [columns]="columns()"
  [isLoading]="isLoading()"
  [tabelWithIcon]="false"
  [withCheckboxSelection]="false"
  [withActions]="false"
  [sortedColumn$]="sortedLastFindingColumn$"
  [pageInfo]="pageInfo()"
  [tableNotFoundText]="'aiFindingPage.noFindingsFound' | labelsProvider"
  tableNotFoundIcon="assets/images/common/no-results-found.svg"
  (rowUnselected)="rowUnselected()"
  (rowSelected)="rowSelected($event)"
  (pageOnChange)="onPagination($event)"
/>
